module.exports = __webpack_public_path__ + "static/img/banner_03.802a6c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner_03.png
// module id = eUfk
// module chunks = 1